export default __webpack_public_path__ + "static/media/google-icon.df15d8e5.svg";